import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, PLATFORM_ID, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { GalleryDto, TenantDto } from '@nusign/picflow-backend-types';
import { BehaviorSubject, map } from 'rxjs';
import { ListGalleriesComponent } from '../../../account/components/list-galleries/list-galleries.component';
import { MadeWithPicflowButtonComponent } from '../../../gallery-shared/components/made-with-picflow-button/made-with-picflow-button.component';
import { AppConfigService } from '../../../providers/config.service';
import { GalleryService } from '../../../services/gallery.service';
import { StateService } from '../../../services/state.service';
import { TenantService } from '../../../services/tenant.service';
import { InfiniteScrollComponent } from '../../../shared/components/infinite-scroll/infinite-scroll.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TenantLogoAndContactsComponent } from '../../../shared/components/tenant-logo-and-contacts/tenant-logo-and-contacts.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TenantIconLoaderComponent } from '../../components/tenant-icon-loader/tenant-icon-loader.component';

@Component({
  selector: 'app-tenant-profile-page',
  templateUrl: './tenant-profile-page.component.html',
  styleUrls: ['./tenant-profile-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonDirective,
    SvgComponent,
    MadeWithPicflowButtonComponent,
    TenantIconLoaderComponent,
    TenantLogoAndContactsComponent,
    InfiniteScrollComponent,
    ListGalleriesComponent,
  ],
})
export class TenantProfilePageComponent implements OnInit {
  public config = inject(AppConfigService);
  public state = inject(StateService);
  private route = inject(ActivatedRoute);
  private platformId = inject(PLATFORM_ID);
  private tenantService = inject(TenantService);
  private galleryService = inject(GalleryService);
  fetchMoreGalleries$ = new BehaviorSubject<void>(undefined);
  lastGallery = signal<GalleryDto>(undefined);
  allGalleriesLoaded = signal(false);
  tenant: TenantDto = this.route.snapshot.data.tenant;
  platformBrowser = isPlatformBrowser(this.platformId);
  showEditBanner = signal(false);
  galleries = toSignal(
    this.galleryService.getTenantProfileGalleriesPaginated(this.fetchMoreGalleries$, this.tenant).pipe(
      map(resp => {
        if (!resp) return [];
        const galleries = resp.galleries;
        this.allGalleriesLoaded.set(!resp.has_more_next);
        this.lastGallery.set(galleries[galleries.length - 1]);
        return [...galleries];
      })
    )
  );

  async ngOnInit() {
    this.showEditBanner.set(await this.shouldShowEditBanner());
  }

  galleryLinkGenerator(gallery: GalleryDto): string {
    console.log(gallery);

    return `/${gallery.id}`;
  }

  private async shouldShowEditBanner() {
    if (!this.platformBrowser) return false;
    const tenant = this.state.tenants?.find(t => t.id === this.tenant.id);
    if (!tenant) return false;
    await this.tenantService.setActiveTenant(tenant);
    const role = this.state.activeTenantRole;
    if (role === 'admin' || role === 'owner') return true;
    return false;
  }
}
